/**
 * Criteo DataLayer 인터페이스
 * @author 장유현
 */

// import md5 from 'md5'

let userAgent; let deviceType; let sha256Email = ''; let md5Email = ''

function setTagData () {
  userAgent = navigator.userAgent
  deviceType = /iPad/.test(userAgent) ? 't' : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(userAgent) ? 'm' : 'd'
}

/* Criteo 고객 이메일 sha256 변환 */
// async function sha256 (message) {
//   const msgBuffer = new TextEncoder('utf-8').encode(message)

//   const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)

//   const hashArray = Array.from(new Uint8Array(hashBuffer))

//   const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('')

//   return hashHex
// }

// function format (email) {
//   return email.toLowerCase().trim()
// }

/* Criteo 상품 상세 태그 */
export function prodTag (item) {
  window.criteo_q = window.criteo_q || []

  try {
    console.log('### Criteo Start ###')
    console.log('### Criteo item ::: ', item)

    setTagData()

    // DEV-6579, 이메일 전달하지 않도록 변경, 20250707
    sha256Email = ''
    md5Email = ''

    window.criteo_q.push(
      { event: 'setAccount', account: 116414 }, // Criteo 계정ID
      { event: 'setEmail', email: sha256Email, hash_method: 'sha256' }, // Email SHA256 변환
      { event: 'setEmail', email: md5Email, hash_method: 'md5' }, // Email MD5 변환
      { event: 'setZipcode', zipcode: '' }, // 배송지 우편번호
      { event: 'setSiteType', type: deviceType }, // 기기 타입
      { event: 'viewItem', item: item.pdNo ?? '' }) // 상품 번호

    console.log('### Criteo END ###')
  } catch (err) {
    console.log('### Criteo Err ::: ', err)
  }
}

/* Criteo 장바구니 태그 */
export function cartTag (item) {
  window.criteo_q = window.criteo_q || []

  try {
    console.log('### Criteo Start ###')
    console.log('### Criteo item ::: ', item)

    setTagData()

    // DEV-6579, 이메일 전달하지 않도록 변경, 20250707
    sha256Email = ''
    md5Email = ''

    window.criteo_q.push(
      { event: 'setAccount', account: 116414 },
      { event: 'setEmail', email: sha256Email, hash_method: 'sha256' },
      { event: 'setEmail', email: md5Email, hash_method: 'md5' },
      { event: 'setZipcode', zipcode: '' },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'viewBasket',
        item: item.cartItem ?? []
      }
    )

    console.log('### Criteo END ###')
  } catch (err) {
    console.log('### Criteo Err ::: ', err)
  }
}

/* Criteo 세일즈 태그 */
export function salesTag (item, email) {
  window.criteo_q = window.criteo_q || []

  try {
    console.log('### Criteo Start ###')
    console.log('### Criteo item ::: ', item)

    setTagData()

    // DEV-6579, 이메일 전달하지 않도록 변경, 20250707
    sha256Email = ''
    md5Email = ''

    const salesItem = []

    const dataList = item.orPdList ?? ''

    dataList.forEach((element) => {
      salesItem.push({
        id: element.pdNo ? element.pdNo : element.bunPdNo ? element.bunPdNo : '',
        price: element.pdPrc ? element.pdPrc : element.price ? element.price : element.sleUtpc ? element.sleUtpc : '',
        quantity: element.spbkQy ?? ''
      })
    })

    window.criteo_q.push(
      { event: 'setAccount', account: 116414 },
      { event: 'setEmail', email: sha256Email, hash_method: 'sha256' },
      { event: 'setEmail', email: md5Email, hash_method: 'md5' },
      { event: 'setZipcode', zipcode: '' },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'trackTransaction',
        id: item.orNo,
        item: salesItem ?? []
      }
    )

    console.log('### Criteo END ###')
  } catch (err) {
    console.log('### Criteo Err ::: ', err)
  }
}

/* Criteo 홈페이지 태그 */
export function homepageTag (item) {
  window.criteo_q = window.criteo_q || []

  try {
    console.log('### Criteo Start ###')
    console.log('### Criteo item ::: ', item)

    setTagData()

    // DEV-6579, 이메일 전달하지 않도록 변경, 20250707
    sha256Email = ''
    md5Email = ''

    window.criteo_q.push(
      { event: 'setAccount', account: 116414 },
      { event: 'setEmail', email: sha256Email, hash_method: 'sha256' },
      { event: 'setEmail', email: md5Email, hash_method: 'md5' },
      { event: 'setZipcode', zipcode: '' },
      { event: 'setSiteType', type: deviceType },
      { event: 'viewHome' })

    console.log('### Criteo END ###')
  } catch (err) {
    console.log('### Criteo Err ::: ', err)
  }
}

/* Criteo 카테고리/검색/리스팅 태그 */
export function listingTag (item) {
  window.criteo_q = window.criteo_q || []

  try {
    console.log('### Criteo Start ###')
    console.log('### Criteo item ::: ', item)

    setTagData()

    // DEV-6579, 이메일 전달하지 않도록 변경, 20250707
    sha256Email = ''
    md5Email = ''

    const listingItem = []

    // 최상위 3개 상품의 상품번호 저장
    if (item.prodList.length > 3) {
      for (let i = 0; i < 3; i++) {
        listingItem.push(item.prodList[i].pdNo)
      }
    } else {
      item.prodList.forEach((value) => {
        listingItem.push(value.pdNo)
      })
    }

    window.criteo_q.push(
      { event: 'setAccount', account: 116414 },
      { event: 'setEmail', email: sha256Email, hash_method: 'sha256' },
      { event: 'setEmail', email: md5Email, hash_method: 'md5' },
      { event: 'setZipcode', zipcode: '' },
      { event: 'setSiteType', type: deviceType },
      { event: 'viewList', item: listingItem ?? '', category: item?.category ?? '', keywords: item?.keywords ?? '' })

    console.log('### Criteo END ###')
  } catch (err) {
    console.log('### Criteo Err ::: ', err)
  }
}

/* Criteo 장바구니 추가 태그 */
export function addCartTag (item) {
  window.criteo_q = window.criteo_q || []

  try {
    console.log('### Criteo Start ###')
    console.log('### Criteo item ::: ', item)

    setTagData()

    // DEV-6579, 이메일 전달하지 않도록 변경, 20250707
    sha256Email = ''
    md5Email = ''

    const addCartItem = []

    if (item?.prodList.length > 0) {
      item?.prodList.forEach((value) => {
        addCartItem.push({
          id: value?.pdNo ?? '',
          price: value?.price ?? '',
          quantity: value?.spbkQy ?? ''
        })
      })
    } else {
      // eslint-disable-next-line no-lonely-if
      if (typeof item?.prodList?.price === 'string') {
        addCartItem.push({
          id: item?.prodList?.pdNo ?? '',
          price: item?.prodList?.price.replaceAll(',', '') ?? '',
          quantity: item?.prodList?.spbkQy ?? ''
        })
      } else {
        addCartItem.push({
          id: item?.prodList?.pdNo ?? '',
          price: item?.prodList?.price ?? '',
          quantity: item?.prodList?.spbkQy ?? ''
        })
      }
    }

    window.criteo_q.push(
      { event: 'setAccount', account: 116414 },
      { event: 'setEmail', email: sha256Email, hash_method: 'sha256' },
      { event: 'setEmail', email: md5Email, hash_method: 'md5' },
      { event: 'setZipcode', zipcode: '' },
      { event: 'setSiteType', type: deviceType },
      { event: 'addToCart', item: addCartItem })

    console.log('### Criteo END ###')
  } catch (err) {
    console.log('### Criteo Err ::: ', err)
  }
}
